<template>
  <div class="solution">
    <div class="banner">
      <div class="title">金融行业解决方案</div>
      <div class="desc">
        <section>为保险、银行、证券等金融企业提供高效内容供给、千人千面分发协作、品牌资产安全管理、</section>
        <section>数据监测回流的全链路数字营销解决方案</section>
      </div>
      <router-link target="_blank"  to='/contact'><div class="button">立即体验<i class="el-icon-right"></i></div></router-link> 
    </div>
    <div class="context">
      <div class="row">
        <div class="introduce right">
          <div class="idesc">
            <section class='title'>痛点</section>
            <section>金融行业全域营销需求旺盛，内容生产门槛高且需求量大，企业设计资源有限，无法及</section>
            <section>时响应总部设计师在内容创作的过程中需要大量的版权素材，成本高且容易遇到版权风</section>
            <section>险</section>
            <section class='title purple'>解决方案</section>
            <section><span class="marginTop">在线设计：</span>爱设计新型在线设计引擎， 0门槛在线作图，赋予企业全员内容生产能力</section>
            <section><span>AI设计：</span>根据金融行业主流营销场景，实现AI批量图片生产及尺寸延展，高效释放内容</section>
            <section>生产力</section>
            <section><span>创意热店：</span>8大创意服务类型以及150+创意服务形式，为品牌提供多元优质的内容创意</section>
            <section>供给和数字化交付</section>
             <section><span>版权素材：</span>亿级版权素材库，涵盖图片、视频、插画、psd、eps 等格式，为设计师提</section>
            <section>供创意灵感来源，商用场景全覆盖，规避版权风险</section>
          </div>
        </div>
        <img class="img" src="https://respool.isheji.com/isheji/static/qiye/image/solution/finance/1.png">
      </div>
      <div class="row drak">
        <img class="img" src="https://respool.isheji.com/isheji/static/qiye/image/solution/finance/2.png">
        <div class="introduce left">
          <div class="idesc">
            <section class='title'>痛点</section>
            <section>金融行业营销内容监管要求复杂，多品牌、跨渠道管理混乱，品牌规范性难以把控</section>
            <section>传统素材内容存储方式，杂乱无序，查找复用效率低下，且随人员流动丢失风险大</section>
            <section class='title purple'>解决方案</section>
            <section><span class="marginTop">品牌规范管理：</span>预设品牌vi规则，包含字体、icon、色值色号等，实现在线管理</section>
            <section><span>权限管理：</span>4级角色权限设置，管理内容的生产，协作，存储，分发及数据权限，保证</section>
            <section>分发内容的品牌合规性</section>
            <section><span>审批管理：</span>标准化的内容分发审批流程，double-check 机制确保内容和品牌的合规</section>
            <section><span>云端储存：</span>通过内容中台的形式在线存储，集中管理</section>
            <section><span>分类管理：</span>通过内容标签及分类的形式高效管理海量创意资源，方便查找及复用</section>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="introduce right">
          <div class="idesc">
            <section class='title'>痛点</section>
            <section>1.私域内容千人千面，传统设计方式机械重复，工作量巨大，分发效率极其低下且容易</section>
            <section>出现品牌合规问题</section>
            <section>2.海量social媒体质量参差不齐，时常遭遇选号盲区，人工沟通投放效率低，反馈慢</section>
            <section class='title purple'>解决方案</section>
            <section><span class="marginTop">私域内容分发：</span>通过 ConTech 创意云内容分发协作能力，智能解析 psd 文件，全员可</section>
            <section>根据自身需求修改本地化、个性化的内容，并一键分发至私域场景</section>
            <section><span>智能选号：</span>依托kolstore，为品牌投放提供智能账号推荐、智能搜索、智能报价单、账</section>
            <section>号数据分析等多维度服务</section>
            <section><span>智能投放：</span>依托平台智能锁定头部KOL的价格、排期、意愿，电话直联及在线沟通等工</section>
            <section>具保障沟通及时高效</section>
          </div>
        </div>
        <img class="img" src="https://respool.isheji.com/isheji/static/qiye/image/solution/finance/3.png">
      </div>
        <div class="row drak">
        <img class="img" :src="`https://respool.isheji.com/isheji/static/qiye/image/home/path_card_9.png`">
        <div class="introduce left">
          <div class="idesc">
            <section class='title'>痛点</section>
            <section>私域内容分发效果无法追溯，营销链路出现断层</section>
            <section class="marginTop16">social 环境多平台，跨渠道的内容分散度极高，内容管理难度大，投放前中后期的全链</section>
            <section>路数据追踪难以把控</section>
            <section class='title purple'>解决方案</section>
            <section><span class="marginTop">可视化数据看板：</span>内容中心超过 100+的数据分析指标，让企业的内容营销数据效果一</section>
            <section>目了然</section>
            <section><span>数据监测回流：</span>端到端的数据监测能力，为企业提供实时的营销数据反馈，反哺内容的</section>
            <section>迭代优化，形成营销闭环</section>
          </div>
        </div>
      </div>
    </div>
     <banner></banner>
  </div>
</template>
<script>
import banner from '@/components/solutionBanner.vue'
export default {
  name: 'finance',
  components: {
    banner,
  },
}
</script>
<style lang="scss" scoped>
.solution{
    width: 100%;
    min-width: 1400px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .banner{
      text-align: center;
      background-image: url('https://respool.isheji.com/isheji/static/qiye/image/solution/finance/banner.png');
      width: 100%;
      min-width: 1400px;
      height: 460px;
      background-size: cover;
      background-position-x: center;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding-top: 60px;
      .title{
        font-size: 32px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 45px;
      }
      .desc{
        margin-top: 20px;
        text-align: center;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 22px;
        margin-bottom: 54px;
      }
     
    }
    .context{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        min-width: 1400px;
      .drak{
        background: #F7F7F9;
      }
      .row{
          padding-top: 120px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        padding-bottom: 115px;
        .left{
          margin-left: 142px;
        }
        .right{
          margin-right: 142px;
        }
        .introduce{
          .iheader{
            display: flex;
            align-items: center;
            img{
              width: 60px;
              height: 60px;
              border-radius: 8px;
            }
            .iTitle{
              margin-left: 18px;
              display: flex;
              flex-direction: column;
              justify-content: center;
            
              .bold{
                font-size: 24px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #3B3946;
                line-height: 33px;
              }
              .thin{
               font-size: 16px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #3B3946;
                line-height: 22px;
              }
            }
          }
          .idesc{
            margin-top: 24px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #6E6C76;
            line-height: 24px;
            margin-bottom: 32px;
            .marginTop16{
              margin-top: 16px;
            }
            .marginTop{
              margin-top: 0;
            }
            span{
              display: inline-block;
              color: #3B3946;
              font-weight: 600;
              margin-top: 16px;
            }
            .title{
                font-size: 20px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #3B3946;
                line-height: 28px;
                margin-bottom: 16px;
                margin-top: 32px;
                position: relative;
                &::before{
                  content: '';
                  width: 30px;
                  height: 30px;
                  background: linear-gradient(270deg, rgba(255, 167, 126, 0) 0%, #FF6E48 100%);
                  border-radius: 17px;
                  position: absolute;
                  bottom: 0;
                  left: -16px;
                }
            }
            .purple{
              &::before{
                  content: '';
                  width: 30px;
                  height: 30px;
                  background: linear-gradient(270deg, rgba(90, 45, 245, 0) 0%, #5A2DF5 100%);
                  border-radius: 17px;
                  position: absolute;
                  bottom: 0;
                  left: -16px;
                }
            }
          }
        }
        .img{
          width: 595px;
        }
        
      }
    }

     .button{
        width: 126px;
        height: 44px;
        background: #5A2DF5;
        border-radius: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 20px;
        cursor: pointer;
          .el-icon-right{
            display: none;
            margin-left: 8px;
          }
        &:hover{
          .el-icon-right{
            display: block;
            color: #FFFFFF;
            margin-left: 8px;
          }
        }
      }
}
</style>